import styled from 'styled-components';
import {device} from 'styled/device';
import {Button} from '../../components/Button';

export const ModalStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 370px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .link {
    margin-top: 30px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #23262f;
    padding-bottom: 30px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  .modalTitle {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 30px;
    font-weight: 400;
    color: #23262f;
    padding: 20px 0 30px 0;
  }

  @media (max-width: ${device.mobileM}) {
    .desktopImage {
      display: none;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const ButtonStyled = styled(Button)`
  width: 100%;

  @media (max-width: ${device.mobileM}) {
    font-size: 14px;
    padding: 0 10px;
    justify-content: center;
  }
`;
